// Spinner.js
import "./Spinner.css";

export default function Spinner() {
    return (
        <div className="spinner"></div>
    );
}
